import { z } from 'zod';

export const RealtimeTokenSchema = z
  .object({
    channel: z.string(),
    topics: z.array(z.string()),
    token: z.string(),
    key: z.string().optional(),
    expiresAt: z.number().optional(),
    app: z
      .object({
        apiBaseUrl: z.string().optional(),
      })
      .optional(),
  })
  .passthrough();

export type RealtimeToken = z.infer<typeof RealtimeTokenSchema>;
